import React, {useRef, useState} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import map from 'assets/img/pages/usr_map.png';
import CommonUtil from 'utils/CommonUtil';
import UI from "../../../../components/UI";
import UIUtils from "utils/UIUtils";
import StringUtil from "../../../../utils/StringUtil";

function ContentsContainer() {
	const history = useHistory();
	const location = useLocation();
	const receivedData = (location.state as any)?.data;

    const [memberList, setMemberList] = useState<any[]>([]);
    const [totalCnt,setTotalCnt] = useState(0);
    const [searchOpt, setSearchOpt] = useState('1');
    const [searchText, setSearchText] = useState('');
    const [personNm, setPeronNm] = useState('');
    const [deptNm, setDeptNm] = useState('');
    const [bizNm, setBizNm] = useState('');
    const [showRowCnt,setShowRowCnt] = useState(10); //기본 row count
    const [cont,setCont] = useState('');

    // 페이징 설정
    const [pageNum, setPageNum] = useState(1);      // 페이지 번호
    const [pageSize, setPageSize] = useState(10);    // 화면에 출력할 목록 갯수(10개)
	const pageCnt = useRef<any>(0);                 // 페이지 갯수

    //초기 데이터 설정
    let param = {};
    let data = {};


    //인풋 엔터체크
    const activeEnter = (e) => {
        if(e.key === "Enter") {
            search("search");
        }
    }

    const handleSelect = (e) => {
        setSearchOpt(e.target.value);
    };

    async function search(type) {

        if(searchOpt == '1'){
            param = { BIZ_NM: searchText }
        } else if(searchOpt == '2') {
            param = { PERSON_NM: searchText }
        } else if(searchOpt == '3') {
            param = { DEPT_NM: searchText }
        }

		if(searchText == ""){
			if(type == "search"){
				UIUtils.alert("검색어를 입력 후 이용해 주세요.").then();
				return;
			} else {
				return;
			}
		} else {
			param = { PAGE_NUM: pageNum,
				PAGE_SIZE: pageSize,
				...param
			}

			const response:any = await CommonUtil.execute({
				url: 'usr_1902',
				data: param
			}).then((response:any) => {
				data = response.REC;

				setMemberList(response.REC);
				setTotalCnt(response.TOTAL);

				let totCnt = response.TOTAL;
				let rowCnt = pageSize;
				pageCnt.current = Math.floor((totCnt % rowCnt) == 0 ? totCnt / rowCnt : totCnt / rowCnt + 1);

			}).catch(err => {
				CommonUtil.showAxiosError(err);
				return;
			});
		}

    }

	React.useEffect(() => {
		console.log(receivedData );
		const receivedFlag = receivedData?.FLAG;
		console.log("receivedFlag : " + receivedFlag);
		if(receivedFlag){
			window.scrollTo(0, 1450);
		}
	}, [])//effect


    React.useEffect(() => {
		if(searchText != "" || searchText != null){
			search("page");
		}
    }, [pageNum, searchOpt])//effect


	return (
		<PageContainer session={false}>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">상생협력기금안내</Link></li>
					<li><Link to="#">기관안내</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<h1 className="tx tx-hd2">기관안내</h1>
					<div className="fww-intro">
						<section className="fww-intro-section">
							<h3 className="title">직원검색</h3>
							<div className="tb-search-form">
								<div className="tb-search-items">
									<div className="sl sl-big">
										<select name="searchOpt" id="searchOpt" value={searchOpt} onChange={handleSelect}>
											<option value="1">업무명</option>
											<option value="2">담당자명</option>
											<option value="3">부서명</option>
										</select>
									</div>
									<UIInput className={'tf tf-big ml10'} value={searchText} placeholder={""} valueChanged={(value) => setSearchText(value)} onKeyEnter={(e) => activeEnter(e)}/>
								</div>
								<Button color="pri" size="big" onClick={() => search("search")}>조회</Button>
							</div>
							<div className="tb tb-narrow" data-bg="white">
								<table>
									<caption></caption>
									<colgroup>
										<col width="190px" />
										<col width="190px" />
										<col width="190px" />
										<col width="190px" />
										<col width="190px" />
										<col />
									</colgroup>
									<thead>
										<tr>
											<th scope="col">이름</th>
											<th scope="col">직위</th>
											<th scope="col">부서</th>
											<th scope="col">업무</th>
											<th scope="col">전화번호</th>
											<th scope="col">이메일</th>
										</tr>
									</thead>
									<tbody>
									    {memberList.length > 0 ? (
                                            memberList.map((member, index) => (
												index <= 9 &&
                                                <tr>
                                                    <td>{member.PERSON_NM}</td>
                                                    <td>{member.POSI_NM}</td>
                                                    <td>{member.DEPT_NM}</td>
                                                    <td>{member.BIZ_NM}</td>
                                                    <td>{StringUtil.telephoneFormat(member.OFC_TEL_NO)}</td>
                                                    <td>{member.EMAIL_ADRES}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={6}>
                                                    <div className="nd">
                                                        <p className="tx tx-cp2 fc-666">검색된 정보가 없습니다.</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
								</table>

								<UI.PaginationBar
                                    totalCnt={totalCnt}
                                    rowCnt={10}
                                    currentPage={pageNum}
                                    onChange={(current:number) => {
                                        setPageNum(current);
                                    }}
                                />

							</div>
						</section>
						<section className="fww-intro-section" id="map">
							<h3 className="title">오시는 길</h3>
							<div className="location">
								<div className="map">
									<img src={map} alt="location" />
								</div>
								<div className="loc-items address">
									<h6>주소</h6>
									04554 서울특별시 중구 퇴계로 173 남산스퀘어빌딩 7층, (fax: 02-368-8709) 
								</div>
								<div className="loc-items bus">
									<h6>버스</h6>
									남산스퀘어 앞 하차
									<ul className="b-line">
										<li className="blue">104, 105, 140, 421, 463, 507, 604번</li>
										<li className="green">7011번</li>
										<li className="night">N16번</li>
									</ul>
								</div>
								<div className="loc-items subway">
									<h6>지하철 </h6>
									3호선, 4호선 충무로역 5번출구에서 도보 500m
									<div className="s-line">
										<span className="line3">3호선</span>
										<span className="line4">4호선</span>
									</div>
								</div>
								
								
							</div>
						</section>
					</div>
				</main>
			</div>			
		</PageContainer>
	);
}
export default ContentsContainer;